const RE_PREFIX = 'Re:';
const DEFAULT_SUBJECT = 'No Subject';

/**
 * Formats a subject line for email replies.
 * Adds Re: prefix if not already present.
 */
export const formatReplySubject = (subject?: string | null): string => {
  const subjectText = subject || DEFAULT_SUBJECT;

  if (subjectText.startsWith(RE_PREFIX)) {
    return subjectText;
  }

  return `${RE_PREFIX} ${subjectText}`;
};
